<template>
  <div class="flex flex-col gap-6 items-start w-full">
    <div class="bg-PRIMARY p-4 flex flex-col gap-2 items-start rounded-xl w-full">
      <p class="text-xs text-GREY">Your Coin</p>
      <p class="font-semibold text-xl">10,942K</p>
    </div>
    <div class="flex flex-col gap-2 items-start w-full">
      <p class="font-semibold">Daily Boosters</p>
      <boost-item size="lg" title="Full Energy" :svg-icon="energyImageUrl" @item-click="openBottomDrawer(EnergyDrawer)">
        <p class="text-xs text-GREY">0/3</p>
      </boost-item>
      <boost-item size="sm" title="Turbo" :svg-icon="turboImageUrl" @item-click="openBottomDrawer(TurboDrawer)">
        <p class="text-xs text-GREY">0/3</p>
      </boost-item>
    </div>
    <div class="flex flex-col gap-2 items-start w-full">
      <p class="font-semibold">Boosters</p>
      <boost-item size="lg" title="Boost x2" :svg-icon="boostImageUrl">
        <p class="text-xs text-GREY">1 Level</p>
        <template #suffix>
          <div class="flex flex-row gap-1 items-center">
            <img src="@/assets/icons/token-2.svg" class="h-full object-contain w-5" />
            <p class="font-semibold text-sm">+100</p>
          </div>
        </template>
      </boost-item>
      <boost-item size="sm" title="Turbo" :svg-icon="turboImageUrl">
        <p class="text-xs text-GREY">1 Level</p>
        <template #suffix>
          <div class="flex flex-row gap-1 items-center">
            <img src="@/assets/icons/token-2.svg" class="h-full object-contain w-5" />
            <p class="font-semibold text-sm">+100</p>
          </div>
        </template>
      </boost-item>
    </div>
  </div>
</template>

<script setup>
import BoostItem from '@/components/BoostItem.vue'
import { openBottomDrawer } from '@/composables/bottomdrawer';
import EnergyDrawer from '../components/drawers/EnergyDrawer.vue';
import TurboDrawer from '../components/drawers/TurboDrawer.vue';

const energyImageUrl = new URL(`../assets/icons/energy.svg`, import.meta.url).href
const turboImageUrl = new URL(`../assets/icons/turbo.svg`, import.meta.url).href
const boostImageUrl = new URL(`../assets/icons/boost.svg`, import.meta.url).href
</script>

<style lang="scss" scoped></style>
